import React from 'react';
import {
  crop as cropFn,
  get as getFn,
  notify as notifyFn,
  create as createFn,
  upload as uploadFn,
} from '../../services/image-service';

import ImageUploadPresentation, { Props as PresentationProps } from './Presentation';

export type Props = Omit<
  PresentationProps,
  'cropFn' | 'getFn' | 'notifyFn' | 'createFn' | 'uploadFn'
>;

const ImageUpload = (props: Props) => (
  <ImageUploadPresentation {...props} {...{ cropFn, getFn, notifyFn, createFn, uploadFn }} />
);

export default ImageUpload;
